// src/config.js
/* const getBaseUrl = () => {
    const hostname = window.location.hostname;
  
    // Check if running locally
    if (hostname === 'localhost') {
      return 'http://localhost:6111';
    }
  
    // If running on the server
    return 'https://apiviztech.in:6111';
  };
  
  const BASE_URL = getBaseUrl();
  
  export default BASE_URL; */

  const getBaseUrl = () => {
  const hostname = window.location.hostname;

  if (hostname === 'localhost') {
    return 'http://localhost:6132';
  }

  // PRODUCTION (same domain)
  //return '/api';
   return ''; // IMPORTANT
};

const BASE_URL = getBaseUrl();
export default BASE_URL;